import { ProfileCardContent } from './ProfileCardContent';
import { ProfileCardPage } from './ProfileCardPage';
import { ProfileCardRoot } from './ProfileCardRoot';
import { ProfilePagePanel } from './ProfilePagePanel';

export const ProfileCard = {
  Root: ProfileCardRoot,
  Content: ProfileCardContent,
  Page: ProfileCardPage,
  PagePanel: ProfilePagePanel,
};
